'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dBase64$002dString$0024$0024anon$002437 from "./presto.types$-Base64-String$$anon$37.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Base64String$() {
  this.c4Y = null;
  this.c4Z = false;
  this.c4W = null;
  this.c4X = false;
  this.c50 = null;
  this.c51 = false;
}
export { $c_Lpresto_types$Base64String$ as $c_Lpresto_types$Base64String$ };
$p = $c_Lpresto_types$Base64String$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Base64String$;
/** @constructor */
function $h_Lpresto_types$Base64String$() {
}
export { $h_Lpresto_types$Base64String$ as $h_Lpresto_types$Base64String$ };
$h_Lpresto_types$Base64String$.prototype = $p;
$p.nR = (function() {
  if ((!this.c4Z)) {
    this.c4Y = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c4Z = true;
  }
  return this.c4Y;
});
$p.ra = (function() {
  if ((!this.c4X)) {
    this.c4W = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c4X = true;
  }
  return this.c4W;
});
$p.cJV = (function() {
  if ((!this.c51)) {
    this.c50 = new $j_presto$002etypes$0024$002dBase64$002dString$0024$0024anon$002437.$c_Lpresto_types$Base64String$$anon$37(this);
    this.c51 = true;
  }
  return this.c50;
});
var $d_Lpresto_types$Base64String$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Base64String$, "presto.types$Base64String$", ({
  YD: 1,
  D: 1
}));
export { $d_Lpresto_types$Base64String$ as $d_Lpresto_types$Base64String$ };
var $n_Lpresto_types$Base64String$;
function $m_Lpresto_types$Base64String$() {
  if ((!$n_Lpresto_types$Base64String$)) {
    $n_Lpresto_types$Base64String$ = new $c_Lpresto_types$Base64String$();
  }
  return $n_Lpresto_types$Base64String$;
}
export { $m_Lpresto_types$Base64String$ as $m_Lpresto_types$Base64String$ };
//# sourceMappingURL=presto.types$-Base64-String$.js.map
